@if (text) {
    <p>{{ text }}</p>
}
<ul>
    @for (color of colors; track color) {
        <li [class.active]="color === colorable.color">
            <div (click)="setColor(color)"
                 [ngStyle]="{'background-color': color | color}"
                 class="color-field"
            ></div>
        </li>
    }
</ul>
